export default {
    pokemonListHeadline: "Seus Pokemon",

    // info panel
    info: "Info",
    team: "Time",
    stats: "Stats",
    moves: "Movimentos",
    movesNotFound: "Não foi possível encontrar seus movimentos",
    name: "Nome",
    hp: "Hp",
    attack: "Ataque",
    specialAttack: "Ataque Esp.",
    defense: "Defesa",
    specialDefense: "Defesa Esp.",
    speed: "Velocidade",
    total: "Total",
    progress: "Progresso",
    weight: "Peso",
    generation: "Geração",
    base_stats: "Base stats",

    // stat values
    horrible: "Horrível",
    bad: "Ruim",
    avg: "Normal",
    good: "Bom",
    fantastic: "Fantástico",
    perfect: "Perfeito",

    // additional infos
    caughtBy: "Capturado by",
    originalChannel: "Origem",
    caughtAtFormat: (year, month, day) => `${month}/${day}/${year}`,

    // selling
    sell: (amount) => `Vender $${amount}`,
    sellConfirmMessage: (name, lvl) => `Seu <span class="font-weight-bold">${name} LVL. ${lvl}</span> irá desaparecer para sempre.<br>Continuar?`,
    trade: 'Trade',
    wondertrade: 'Wondertrade',
    tradeConfirmMessage: (name, lvl) => `Seu <span class="font-weight-bold">${name} LVL. ${lvl}</span> irá desaparecer para sempre.<br>Continuar?`,
    sellSuccess: "Você vendeu o seu Pokemon com sucesso",
    sellLast: "Você nao pode vender o seu último Pokemon",
    sellNotExists: "Esse Pokemon não existe atualmente",
    sellNotYourPokemon: "Esse Pokemon não é seu atualmente",
    sellPriceChanged: "O preço do seu Pokemon mudou. Por favor recarregue a extensão",

    tradeCooldown: (time) => `Cooldown: ${time}`,
    tradeCooldownIsActive: "Você já fez o wondertrade nas últimas 3 horas",

    // sort filter
    changeSort: "Alterar classificação",
    sortByID: "ID",
    sortByName: "Nome",
    sortByLevel: "Level",
    sortByHP: "HP",
    sortByPrice: "Preço",
    sortByShiny: "Shiny",
    sortByBaseStat: "Base stats",
    sortByAvgIV: "IV",
    sortByRecent: "Recente",

    // error messages
    PokemonTeamFull: "Seu time está cheio",
    PokemonNotInTeam: "Esse Pokemon não está no seu time",
    PokemonAlreadyInTeam: "Esse Pokemon já está no seu time",
    PokemonNotOwnedAnymore: "Você nao possui este Pokemon atualmente",

    PokemonNicknameTooLong: "Esse nome é longo demais",
    PokemonTeamNameTooLong: "Esse nome é longo demais",

    caughtOn: "Caught on"
};